import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import decode from "jwt-decode";
import ResetForm from "../forms/ResetForm";
import { login, isTokenValid, checkSec } from "../../actions/auth";
import { loadUi } from "../../actions/search";
import { getUserGlb } from "../../actions/userGlb";
import ChangePasswordSteps from "./ChangePasswordSteps";
import SideInfoPane from "../navigation/SideInfoPane";
import ChangePasswordForm from "../forms/ChangePasswordForm";
import SecurityQuestionsSetupForm from "../forms/SecurityQuestionsSetupForm";
import GlbRegisterForm from "../forms/GlbRegisterForm";
import api from "../../api";
import settings from "../../settings";
import setAuthorizationHeader from "../../utils/setAuthorizationHeader";
import "../../App.css";
import TopNavigation from "../navigation/TopNavigation";

class CreatePasswordPage extends React.Component {
  constructor(props) {
    super(props);
    const steps = [];
    let resetkey = "";
    if (props.location.search && props.location.search !== "") {
      const params = new URLSearchParams(props.location.search);
      resetkey = params.get("resetkey");
    }
    if (resetkey && resetkey !== "") {
      steps[0] = 2;
      steps[1] = 2;
      steps[2] = 1;
      steps[3] = 0;
      steps[4] = 0;
    } else {
      steps[0] = 1;
      steps[1] = 0;
      steps[2] = 0;
      steps[3] = 0;
      steps[4] = 0;
    }
    let resetError = "";
    if (localStorage.loginFailed) {
      resetError = localStorage.loginFailed;
    }
    this.state = {
      resetError,
      changePasswordError: "",
      confirmationMessage: "",
      securityQuestionsSetupError: "",
      steps,
      resetkey,
      qaItem: undefined,
      user: {},
    };
  }

  setToken = (token) => {
    const payload = decode(token);
    localStorage.expires = payload.exp;
    setAuthorizationHeader(token);
  };

  submit = (data) =>
    api.user
      .resetPasswordToTemp({
        userCode: data.username,
        appname: settings.appName,
        emailType: "PasswordResetEmail",
        linkAction: "createnewpassword",
        responseEmailType: "ConfirmEmail",
      })
      .then((res) => {
        if (res.data.Error) {
          this.setState({ resetError: res.data.Error.Message });
        } else {
          const steps = [];
          steps[0] = 2;
          steps[1] = 1;
          steps[2] = 0;
          steps[3] = 0;
          steps[4] = 0;
          this.setState({ steps, confirmationMessage: res.data.Message });
        }
      })
      .catch((err) => console.log("response err - ", err.response));

  submitChangePassword = (data) => {
    this.setState({
      user: { username: data.username, password: data.password },
    });
    return api.user
      .changePassword({
        userCode: data.username,
        resetkey: this.state.resetkey,
        appname: settings.appName,
        password: data.password,
      })
      .then((res) => {
        if (res.data.Status && res.data.Status === "Error") {
          this.setState({ changePasswordError: res.data.Message });
        } else {
          api.user
            .checkQaSetup({
              usercode: data.username,
            })
            .then((result) => {
              if (result.data.Status && result.data.Status === "Error") {
                const steps = [];
                steps[0] = 2;
                steps[1] = 2;
                steps[2] = 2;
                steps[3] = 1;
                steps[4] = 0;
                this.setState({ steps, confirmationMessage: res.data.Data });
              } else if (result.data.Message === "success") {
                this.checkGlbSetup();
              }
            })
            .catch((err) => console.log("response err - ", err.response));
        }
      })
      .catch((err) => console.log("response err - ", err));
  };

  submitSecurityQuestions = (questionSets) => {
    const qaList = [];
    let qaItem;
    _.forEach(questionSets, (questionSet) => {
      qaList.push({
        id: questionSet.selected.id,
        value: questionSet.selected.value,
      });
      if (!qaItem) {
        const selectedOption = _.find(
          questionSet.options,
          (o) => o.value === questionSet.selected.id
        );
        if (selectedOption) {
          qaItem = {
            question: selectedOption.text,
            answer: questionSet.selected.value,
          };
        }
      }
    });
    this.setState({ loading: true, qaItem });
    return api.user
      .setupQa(this.state.user.username, qaList)
      .then((res) => {
        if (res.data.Status === "Error") {
          this.setState({
            securityQuestionsSetupError: res.data.Message,
            loading: false,
          });
        } else {
          this.checkGlbSetup();
        }
      })
      .catch((err) => {
        this.setState({ errors: err.response.data.errors, loading: false });
      });
  };

  submitGlbPurpose = (glbPurpose) => {
    this.setState({ loading: true });
    return api.user
      .setupGlb(this.state.user.username, glbPurpose)
      .then((res) => {
        if (res.data.Status === "Error") {
          this.setState({
            glbSetupError: res.data.Message,
            loading: false,
          });
        } else {
          this.loginUser();
        }
      })
      .catch((err) => {
        this.setState({ errors: err.response.data.errors, loading: false });
      });
  };

  checkGlbSetup() {
    api.user
      .checkGlbSetup(this.state.user.username)
      .then((result) => {
        if (result.data.Status && result.data.Status === "Error") {
          const steps = [];
          steps[0] = 2;
          steps[1] = 2;
          steps[2] = 2;
          steps[3] = 2;
          steps[4] = 1;
          this.setState({
            steps,
            securityQuestionsSetupError: result.data.Message,
          });
        } else if (result.data.Message === "success") {
          if (result.data.Data.HasGlbSetup) {
            this.loginUser();
          } else {
            const steps = [];
            steps[0] = 2;
            steps[1] = 2;
            steps[2] = 2;
            steps[3] = 2;
            steps[4] = 1;
            this.setState({ steps, userInfo: result.data.Data });
          }
        }
      })
      .catch((err) => console.log("response err - ", err.response));
  }

  loginUser() {
    this.props
      .login({
        username: this.state.user.username,
        password: this.state.user.password,
        appname: settings.appName,
      })
      .then(() => {
        if (!localStorage.appToken) {
          this.setState({
            loginError: "Invalid username or password",
          });
        } else {
          this.setToken(localStorage.appToken);
          if (!this.state.qaItem) {
            window.location.href = `/securitytoken`;
            return;
          }
          const qaList = [];
          qaList.push(this.state.qaItem);
          this.props.checkSec(qaList).then((res) => {
            if (localStorage.sessionID) {
              this.props
                .getUserGlb()
                .then(() => {
                  this.props
                    .loadUi()
                    .then(() => {
                      window.location.href = `/searchOptions`;
                    })
                    .catch((err) =>
                      console.log(
                        "Error during loadui - ",
                        err,
                        " - ",
                        err.response
                      )
                    );
                })
                .catch((err) =>
                  console.log(
                    "Error while fetch user glb - ",
                    err,
                    " - ",
                    err.response
                  )
                );
            } else {
              this.setState({ respData: JSON.stringify(res.data.QAErrorList) });
            }
          });
        }
      })
      .catch((err) => console.log("response err - ", err.response));
  }

  render() {
    return (
      <div>
        <TopNavigation />
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="container-fluid padding-top-20">
            {this.state.steps[0] === 1 && (
              <div className="row login-box">
                <div className="row" colSpan={3}>
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-11 col-md-11 col-sm-11">
                    <div className="padding-top-10" />
                    <ChangePasswordSteps steps={this.state.steps} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-5 col-md-5 col-sm-5 login-box-left">
                    <div className="padding-top-10" />

                    <h2 className="font-family">Password Reset</h2>

                    <ResetForm
                      submit={this.submit}
                      resetError={this.state.resetError}
                    />
                    <div className="padding-top-10" />

                    <div className="padding-top-20 hide-on-smallscreen padding-top-3" />
                  </div>

                  <div className="col-lg-2 col-md-2 col-sm-2" />

                  <div className="col-lg-4 col-md-4 col-sm-4 login-box-right padding-top-25">
                    <SideInfoPane />
                  </div>
                </div>
              </div>
            )}
            {this.state.steps[1] === 1 && (
              <div className="row login-box">
                <div className="row" colSpan={3}>
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-11 col-md-11 col-sm-11">
                    <div className="padding-top-10" />
                    <ChangePasswordSteps steps={this.state.steps} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-5 col-md-5 col-sm-5 login-box-left">
                    <div className="padding-top-10" />

                    <h2 className="font-family">New User Account Activation</h2>
                    <div
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: this.state.confirmationMessage,
                      }}
                    />
                    <div className="padding-top-10" />

                    <div className="padding-top-20 hide-on-smallscreen padding-top-3" />
                  </div>

                  <div className="col-lg-2 col-md-2 col-sm-2" />

                  <div className="col-lg-4 col-md-4 col-sm-4 login-box-right padding-top-25">
                    <SideInfoPane />
                  </div>
                </div>
              </div>
            )}
            {this.state.steps[2] === 1 && (
              <div className="row login-box">
                <div className="row" colSpan={3}>
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-11 col-md-11 col-sm-11">
                    <div className="padding-top-10" />
                    <ChangePasswordSteps steps={this.state.steps} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-5 col-md-5 col-sm-5 login-box-left">
                    <div className="padding-top-10" />

                    <h2 className="font-family">New Password Activation</h2>
                    <ChangePasswordForm
                      submit={this.submitChangePassword}
                      changePasswordError={this.state.changePasswordError}
                    />
                    <div className="padding-top-10" />

                    <div className="padding-top-20 hide-on-smallscreen padding-top-3" />
                  </div>

                  <div className="col-lg-2 col-md-2 col-sm-2" />

                  <div className="col-lg-4 col-md-4 col-sm-4 login-box-right padding-top-25">
                    <SideInfoPane />
                  </div>
                </div>
              </div>
            )}
            {this.state.steps[3] === 1 && (
              <div className="row login-box">
                <div className="row" colSpan={3}>
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-11 col-md-11 col-sm-11">
                    <div className="padding-top-10" />
                    <ChangePasswordSteps steps={this.state.steps} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-5 col-md-5 col-sm-5 login-box-left">
                    <div className="padding-top-10" />

                    <h2 className="font-family">Security Questions Set Up</h2>
                    <SecurityQuestionsSetupForm
                      username={this.state.user && this.state.user.username}
                      submit={this.submitSecurityQuestions}
                      securityQuestionsSetupError={
                        this.state.securityQuestionsSetupError
                      }
                    />
                    <div className="padding-top-10" />

                    <div className="padding-top-20 hide-on-smallscreen padding-top-3" />
                  </div>

                  <div className="col-lg-2 col-md-2 col-sm-2" />

                  <div className="col-lg-4 col-md-4 col-sm-4 login-box-right padding-top-25">
                    <SideInfoPane />
                  </div>
                </div>
              </div>
            )}
            {this.state.steps[4] === 1 && (
              <div className="row login-box">
                <div className="row" colSpan={3}>
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-11 col-md-11 col-sm-11">
                    <div className="padding-top-10" />
                    <ChangePasswordSteps steps={this.state.steps} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-1 col-md-1 col-sm-1" />
                  <div className="col-lg-5 col-md-5 col-sm-5 login-box-left">
                    <div className="padding-top-10" />

                    <h2 className="font-family">GLB Set Up</h2>
                    <GlbRegisterForm
                      userCode={this.state.user && this.state.user.username}
                      userInfo={this.state.userInfo}
                      submit={this.submitGlbPurpose}
                      glbSetupError={this.state.glbSetupError}
                    />
                    <div className="padding-top-10" />

                    <div className="padding-top-20 hide-on-smallscreen padding-top-3" />
                  </div>

                  <div className="col-lg-2 col-md-2 col-sm-2" />

                  <div className="col-lg-4 col-md-4 col-sm-4 login-box-right padding-top-25">
                    <SideInfoPane />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.user.token,
  };
}

export default connect(mapStateToProps, {
  login,
  isTokenValid,
  checkSec,
  getUserGlb,
  loadUi,
})(CreatePasswordPage);



// WEBPACK FOOTER //
// ./src/components/pages/CreatePasswordPage.js